"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onCurrencyFilter = exports.CurrencyFilter = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _ykbUtils = require("ykb-utils");
var _Button = _interopRequireDefault(require("../../Button"));
var _CurrencyInput = _interopRequireDefault(require("../../CurrencyInput"));
var _NumberFilter2 = require("./NumberFilter");
var _FilterFooter = _interopRequireDefault(require("./FilterFooter"));
var _StyledFilterDropdown = require("../styled/StyledFilterDropdown");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CurrencyFilter = exports.CurrencyFilter = /*#__PURE__*/function (_NumberFilter) {
  function CurrencyFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, CurrencyFilter);
    _this = _callSuper(this, CurrencyFilter, [props]);
    (0, _defineProperty2.default)(_this, "setMin", function (e) {
      e.preventDefault();
      _this.setState({
        min: _ykbUtils.currencyFormatter.format((0, _NumberFilter2.findMin)(_this.props.data, _this.props.dataIndex), _this.props.currencyType, _this.props.currencyPrecision)
      });
    });
    (0, _defineProperty2.default)(_this, "setMax", function (e) {
      e.preventDefault();
      _this.setState({
        max: _ykbUtils.currencyFormatter.format((0, _NumberFilter2.findMax)(_this.props.data, _this.props.dataIndex), _this.props.currencyType, _this.props.currencyPrecision)
      });
    });
    (0, _defineProperty2.default)(_this, "onMinChange", function (_ref) {
      var value = _ref.target.value;
      _this.setState({
        min: value
      });
    });
    (0, _defineProperty2.default)(_this, "onMaxChange", function (_ref2) {
      var value = _ref2.target.value;
      _this.setState({
        max: value
      });
    });
    return _this;
  }
  (0, _inherits2.default)(CurrencyFilter, _NumberFilter);
  return (0, _createClass2.default)(CurrencyFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        setSelectedKeys = _this$props.setSelectedKeys,
        _confirm = _this$props.confirm,
        _clearFilters = _this$props.clearFilters,
        locale = _this$props.locale,
        currencyType = _this$props.currencyType,
        currencyPrecision = _this$props.currencyPrecision;
      var _this$state = this.state,
        min = _this$state.min,
        max = _this$state.max;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_StyledFilterDropdown.StyledFilterContentContainer, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        link: "#",
        onClick: this.setMin
      }, "Minimum")), /*#__PURE__*/_react.default.createElement(_CurrencyInput.default, {
        size: "small",
        value: min || '',
        onChange: this.onMinChange,
        currencyType: currencyType && currencyType !== ' ' ? currencyType : '',
        decimalLimit: currencyPrecision
      }), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        link: "#",
        onClick: this.setMax
      }, "Maximum")), /*#__PURE__*/_react.default.createElement(_CurrencyInput.default, {
        size: "small",
        value: max || '',
        onChange: this.onMaxChange,
        currencyType: currencyType && currencyType !== ' ' ? currencyType : '',
        decimalLimit: currencyPrecision
      }), /*#__PURE__*/_react.default.createElement("p", null, " ")), /*#__PURE__*/_react.default.createElement(_FilterFooter.default, {
        locale: locale,
        confirm: function confirm() {
          setSelectedKeys([{
            min: _this2.state.min === null ? null : parseFloat(_this2.state.min.replace(/\./g, '').replace(',', '.')),
            max: _this2.state.max === null ? null : parseFloat(_this2.state.max.replace(/\./g, '').replace(',', '.'))
          }]);
          setTimeout(function () {
            _confirm();
          }, 0);
        },
        clearFilters: function clearFilters() {
          _this2.setState({
            min: null,
            max: null
          }, function () {
            setSelectedKeys([]);
            setTimeout(function () {
              _clearFilters();
            }, 0);
          });
        }
      }));
    }
  }]);
}(_NumberFilter2.NumberFilter);
/**
 *
 * @param {string} dataIndex
 * @param {object|string} value
 * @param {object} record
 */
var onCurrencyFilter = exports.onCurrencyFilter = function onCurrencyFilter(dataIndex, value, record) {
  if (!value) return false;
  var number = record[dataIndex];
  if (number === null || number === undefined) return false;

  // is real float or string?
  if (typeof number === 'string') {
    number = parseFloat(number.replace(/\./g, '').replace(',', '.'));
  }
  if (value.min && value.max) {
    return value.min <= number && value.max >= number;
  } else if (value.min) {
    return value.min <= number;
  } else if (value.max) {
    return value.max >= number;
  }
  return false;
};